import React from 'react';

import { CityContacts } from 'interfaces';

import DepartmentContactItem from './DepartmentContactItem';

interface Props {
  title: string;
  contacts: CityContacts[];
}

const DepartmentContacts = ({ title, contacts }: Props) => {
  return (
    <div className="contact-content-item">
      <h6 className="title">{title}</h6>
      {contacts.map((department) => (
        <DepartmentContactItem
          key={title}
          name={department.departmentContacts[0].name}
          phone={department.departmentContacts[0].phone}
          address1={department.address1}
          address2={department.address2}
        />
      ))}
    </div>
  );
};

export default DepartmentContacts;
